export default {
    defaults: {},
    constants: {},
}
